import React from 'react';
import { _cs, isDefined } from '@togglecorp/fujs';
import { IoClose, IoTimeOutline } from '../../node_modules/react-icons/io5/index.esm.js';
import { genericMemo } from '../../utils/index.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import useBlurEffect from '../../hooks/useBlurEffect.js';
import useBooleanState from '../../hooks/useBooleanState.js';
import InputContainer from '../InputContainer/index.js';
import RawInput from '../RawInput/index.js';
import TimeInput from '../TimeInput/index.js';
import Button from '../Button/index.js';
import Popup from '../Popup/index.js';
import styles from './styles.css.js';

var _IoClose, _IoTimeOutline;

function TimeRangeInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    inputElementRef,
    containerRef: containerRefFromProps,
    inputSectionRef,
    inputClassName,
    variant,
    value,
    onChange,
    name
  } = props;
  const createdContainerRef = React.useRef(null);
  const popupRef = React.useRef(null);
  const containerRef = containerRefFromProps ?? createdContainerRef;
  const uiModeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  const [showTimePicker, setShowTimePickerTrue, setShowTimePickerFalse,, toggleShowTimePicker] = useBooleanState(false);
  const [tempTime, setTempTime] = React.useState({
    startTime: undefined,
    endTime: undefined
  });
  const hideTimePicker = React.useCallback(() => {
    setTempTime({
      startTime: undefined,
      endTime: undefined
    });
    setShowTimePickerFalse();
  }, [setShowTimePickerFalse, setTempTime]);
  const handlePopupBlur = React.useCallback((isClickedOnPopup, isClickedOnParent) => {
    const isClickedWithin = isClickedOnPopup || isClickedOnParent;

    if (!isClickedWithin) {
      hideTimePicker();
    }
  }, [hideTimePicker]);
  useBlurEffect(showTimePicker, handlePopupBlur, popupRef, containerRef);
  const handleClearButtonClick = React.useCallback(() => {
    if (onChange) {
      onChange(undefined, name);
    }
  }, [onChange, name]);
  const handleTimeInputChange = React.useCallback((newValue, inputName) => {
    setTempTime(prevTempTime => ({ ...prevTempTime,
      [inputName]: newValue
    }));
  }, [setTempTime]);
  const handleApplyButtonClick = React.useCallback(() => {
    if (onChange) {
      onChange(tempTime, name);
    }

    hideTimePicker();
  }, [tempTime, name, onChange, hideTimePicker]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputContainer, {
    containerRef: containerRef,
    inputSectionRef: inputSectionRef,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !readOnly && /*#__PURE__*/React.createElement(React.Fragment, null, value && /*#__PURE__*/React.createElement(Button, {
      name: undefined,
      variant: "action",
      onClick: handleClearButtonClick,
      disabled: disabled,
      title: "Clear"
    }, _IoClose || (_IoClose = /*#__PURE__*/React.createElement(IoClose, null))), /*#__PURE__*/React.createElement(Button, {
      name: undefined,
      variant: "action",
      onClick: toggleShowTimePicker,
      disabled: disabled,
      title: "Show time picker"
    }, _IoTimeOutline || (_IoTimeOutline = /*#__PURE__*/React.createElement(IoTimeOutline, null))))),
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    inputContainerClassName: styles.inputContainer,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    variant: variant,
    input: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RawInput, {
      name: "startTime",
      className: _cs(styles.input, styles.startTimeInput, uiModeClassName, !!error && styles.errored, inputClassName),
      elementRef: inputElementRef,
      onFocus: setShowTimePickerTrue,
      readOnly: true,
      uiMode: uiMode,
      disabled: disabled,
      type: "time",
      value: value === null || value === void 0 ? void 0 : value.startTime
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.separator
    }, "to"), /*#__PURE__*/React.createElement(RawInput, {
      name: "endTime",
      className: _cs(styles.input, styles.endTimeInput, uiModeClassName, !!error && styles.errored, inputClassName),
      elementRef: inputElementRef,
      onFocus: setShowTimePickerTrue,
      readOnly: true,
      uiMode: uiMode,
      disabled: disabled,
      type: "time",
      value: value === null || value === void 0 ? void 0 : value.endTime
    }))
  }), !readOnly && /*#__PURE__*/React.createElement(Popup, {
    parentRef: containerRef,
    elementRef: popupRef,
    show: showTimePicker,
    freeWidth: true,
    className: styles.picker,
    contentClassName: styles.content
  }, /*#__PURE__*/React.createElement(TimeInput, {
    className: styles.startTimeInput,
    name: "startTime",
    label: "From",
    value: tempTime.startTime,
    onChange: handleTimeInputChange
  }), /*#__PURE__*/React.createElement(TimeInput, {
    className: styles.endTimeInput,
    name: "endTime",
    label: "To",
    value: tempTime.endTime,
    onChange: handleTimeInputChange
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.applyButton,
    name: undefined,
    onClick: handleApplyButtonClick,
    disabled: !isDefined(tempTime.startTime) || !isDefined(tempTime.endTime)
  }, "Apply"))));
}

var index = genericMemo(TimeRangeInput);

export { index as default };
//# sourceMappingURL=index.js.map
